/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Empty_TitleInputs */

const en_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No drills available yet`)
};

const es_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay ejercicios disponibles`)
};

const de_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Übungen verfügbar`)
};

const zh_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有可用的练习`)
};

const ar_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد تمارين متاحة بعد`)
};

const fr_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun exercice disponible pour l'instant`)
};

const vi_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có bài tập`)
};

const sw_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bado hakuna mazoezi yanayopatikana`)
};

const th_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีการฝึกซ้อม`)
};

const bs_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Još nema dostupnih vježbi`)
};

const ja_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだドリルはありません`)
};

const ko_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 이용 가능한 드릴이 없습니다`)
};

const pt_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há exercícios disponíveis`)
};

const it_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun esercizio ancora disponibile`)
};

const sv_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga övningar tillgängliga ännu`)
};

const nl_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen oefeningen beschikbaar`)
};

const da_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen øvelser tilgængelige endnu`)
};

const nb_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen øvelser tilgjengelig ennå`)
};

const fi_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei harjoituksia vielä saatavilla`)
};

const pl_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak jeszcze ćwiczeń`)
};

const ru_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упражнений пока нет`)
};

const tr_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz alıştırma yok`)
};

const hi_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक उपलब्ध कोई ड्रिल नहीं है`)
};

const id_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada latihan yang tersedia`)
};

const ms_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada latih tubi tersedia`)
};

const cs_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím nejsou k dispozici žádná cvičení`)
};

const el_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν υπάρχουν ακόμη διαθέσιμες ασκήσεις`)
};

const he_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין תרגילים זמינים עדיין`)
};

const af_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen oefeninge beskikbaar nie`)
};

const hu_practice_empty_title = /** @type {(inputs: Practice_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Még nincsenek elérhető gyakorlatok`)
};

/**
* | output |
* | --- |
* | "No drills available yet" |
*
* @param {Practice_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_empty_title = /** @type {((inputs?: Practice_Empty_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Empty_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_empty_title(inputs)
	if (locale === "de") return de_practice_empty_title(inputs)
	if (locale === "zh") return zh_practice_empty_title(inputs)
	if (locale === "ar") return ar_practice_empty_title(inputs)
	if (locale === "fr") return fr_practice_empty_title(inputs)
	if (locale === "vi") return vi_practice_empty_title(inputs)
	if (locale === "sw") return sw_practice_empty_title(inputs)
	if (locale === "th") return th_practice_empty_title(inputs)
	if (locale === "bs") return bs_practice_empty_title(inputs)
	if (locale === "ja") return ja_practice_empty_title(inputs)
	if (locale === "ko") return ko_practice_empty_title(inputs)
	if (locale === "pt") return pt_practice_empty_title(inputs)
	if (locale === "it") return it_practice_empty_title(inputs)
	if (locale === "sv") return sv_practice_empty_title(inputs)
	if (locale === "nl") return nl_practice_empty_title(inputs)
	if (locale === "da") return da_practice_empty_title(inputs)
	if (locale === "nb") return nb_practice_empty_title(inputs)
	if (locale === "fi") return fi_practice_empty_title(inputs)
	if (locale === "pl") return pl_practice_empty_title(inputs)
	if (locale === "ru") return ru_practice_empty_title(inputs)
	if (locale === "tr") return tr_practice_empty_title(inputs)
	if (locale === "hi") return hi_practice_empty_title(inputs)
	if (locale === "id") return id_practice_empty_title(inputs)
	if (locale === "ms") return ms_practice_empty_title(inputs)
	if (locale === "cs") return cs_practice_empty_title(inputs)
	if (locale === "el") return el_practice_empty_title(inputs)
	if (locale === "he") return he_practice_empty_title(inputs)
	if (locale === "af") return af_practice_empty_title(inputs)
	if (locale === "hu") return hu_practice_empty_title(inputs)
	return en_practice_empty_title(inputs)
});